import { type FC } from "react";

import {
    ATTRIBUTES,
    AUTH_SCHEMES,
    type ConfigData,
    DEFAULT_LOCALE,
    SnapAdsGlobalNav,
    VARIANTS,
} from "@snapchat/ads-global-nav";

import { GLOBAL_NAV_CONFIG_BUCKET_URL } from "../../shared/constants";
import { featureGates } from "../constants/globalNavFeatureGates";
import { useAdAccounts } from "../hooks/useAdAccounts";

export const GlobalNav: FC = () => {
    const { orgId, adAccounts, loading, error } = useAdAccounts();

    const adAccountId = adAccounts.length > 0 ? adAccounts[0]?.id : null;

    const variant = adAccountId ? VARIANTS.SSA_AD_ACCOUNTS_V2 : VARIANTS.SSA_AD_ACCOUNTS_V2_NO_AD_ACCOUNT;

    const authScheme = AUTH_SCHEMES.SSO;
    const navAttributes = adAccountId ? [] : [ATTRIBUTES.PROVISIONAL_ORGANIZATION];

    const configData: ConfigData = {
        bucket: GLOBAL_NAV_CONFIG_BUCKET_URL,
        locale: DEFAULT_LOCALE,
        variant,
        authScheme,
    };

    if (loading || error) {
        return null;
    }

    return (
        <SnapAdsGlobalNav
            attributes={navAttributes}
            configData={configData}
            disabled={false}
            featureGates={featureGates}
            isReadOnly={false}
            relativeRoutesQuery={{}}
            routeData={{
                organizationId: orgId ?? "",
                adAccountId: adAccountId ?? "",
            }}
            router={undefined}
            selectedTargetId={"MY_LENSES"}
            mode="dropdown"
        />
    );
};
